/**
 * CIENA — Strict search routing
 * ---------------------------------------------------------------------------------------------------
 * Termos de categoria/família exatos NÃO devem cair no /search nativo do Shopify (que é mais amplo:
 * inclui body/SEO/fuzzy/semântico e mistura resultados — ex.: shorts/bonés/denim numa busca de "camiseta").
 *
 * O autocomplete (predictive, via /search/suggest com `tag`) continua igual. Só o SUBMIT — Enter ou o
 * botão "Pesquisar X →" — é interceptado: se o termo está no mapa strict, redireciona p/ a coleção por
 * tag correspondente; senão, deixa o /search nativo (long-tail e nomes de produto).
 *
 * Intercepta em capture phase (antes do handler do PredictiveSearch). Mapa do handoff do Codex;
 * URLs validadas (todas 200 com produtos). Não esconde nem altera o autocomplete.
 * ---------------------------------------------------------------------------------------------------
 */
(function () {
  if (window.__cienaStrictSearch) return;
  window.__cienaStrictSearch = true;

  var strictSearchRoutes = {
    classic: '/collections/tops/classic-tee',
    'classic tee': '/collections/tops/classic-tee',
    'camiseta leve': '/collections/tops/classic-tee',
    'camisetas leves': '/collections/tops/classic-tee',

    heavy: '/collections/tops/heavy-tee',
    'heavy tee': '/collections/tops/heavy-tee',
    'camiseta pesada': '/collections/tops/heavy-tee',
    'camisetas pesadas': '/collections/tops/heavy-tee',

    camiseta: '/collections/tops/camisetas',
    camisetas: '/collections/tops/camisetas',
    tee: '/collections/tops/camisetas',
    't-shirt': '/collections/tops/camisetas',
    tshirt: '/collections/tops/camisetas',

    casaco: '/collections/tops/casaco',
    casacos: '/collections/tops/casaco',
    jaqueta: '/collections/tops/jaquetas',
    jaquetas: '/collections/tops/jaquetas',

    moletom: '/collections/all/moletom',
    moleton: '/collections/all/moletom',
    moletons: '/collections/all/moletom',
  };

  function normalize(value) {
    return (value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function routeFor(value) {
    return strictSearchRoutes[normalize(value)] || null;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') return;
      // só formulários de busca (header e página de busca)
      if (!form.matches('form[role="search"], form.search')) return;

      var input = form.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;

      // se o usuário selecionou um resultado no autocomplete, não interfere
      if (form.querySelector('[aria-selected="true"] a')) return;

      var route = routeFor(input.value);
      if (!route) return; // long-tail / nome de produto → /search nativo

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(route);
    },
    true // capture: roda antes do handler do PredictiveSearch
  );
})();
